import { render, staticRenderFns } from "./TeachingPlan.vue?vue&type=template&id=4d5223e2&scoped=true&"
import script from "./TeachingPlan.vue?vue&type=script&lang=js&"
export * from "./TeachingPlan.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPlan.vue?vue&type=style&index=0&id=4d5223e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5223e2",
  null
  
)

export default component.exports